import { __rest } from 'tslib';
import { jsx, jsxs } from 'react/jsx-runtime';
import React__default from 'react';
import { styled } from '@mui/material/styles';
import MuiButton from '@mui/material/Button';
import MuiCircularProgress from '@mui/material/CircularProgress';
import Hint from '../Hint/Hint.js';
import ConditionalWrapper from '../../utils/ConditionalWrapper.js';

const buttonStyles = (theme) => ({
    large: {
        iconButtonSize: 36,
        buttonPadding: theme.spacing(0.5, 5),
        iconEndMargin: theme.spacing(0, -1, 0, 2.5),
        iconStartMargin: theme.spacing(0, 2.5, 0, -1),
    },
    medium: {
        iconButtonSize: 30,
        buttonPadding: theme.spacing(0.5, 4),
        iconEndMargin: theme.spacing(0, -1, 0, 2),
        iconStartMargin: theme.spacing(0, 2, 0, -1),
    },
    small: {
        iconButtonSize: 20,
        buttonPadding: theme.spacing(0.5, 3, 0.5),
        iconEndMargin: theme.spacing(0, -1, 0, 1),
        iconStartMargin: theme.spacing(0, 1, 0, -1),
    },
});
const _Button = styled(MuiButton, {
    shouldForwardProp: prop => !['iconButton', 'loading', 'focused', 'blockPointerEventsWhenDisabled'].includes(prop),
}) `
  ${({ theme, loading, disabled, iconButton, blockPointerEventsWhenDisabled, size = 'medium' }) => {
    const { buttonPadding, iconEndMargin, iconStartMargin, iconButtonSize } = buttonStyles(theme)[size];
    return `
      padding: ${iconButton ? 0 : buttonPadding};
      pointer-events: ${loading ? 'none' : 'auto'};
      color: ${loading && 'transparent !important'};
      cursor: ${!loading || !disabled ? 'pointer' : 'initial'}
      .MuiButton-endIcon {
        margin: ${iconEndMargin};
      }
      .MuiButton-startIcon {
        margin: ${iconStartMargin};
      }
      ${iconButton &&
        `
        min-width: unset;
        width: ${iconButtonSize}px;
      `}
      ${iconButton &&
        disabled &&
        `
        &.Mui-disabled {
          color: ${theme.palette.N30.main};
          pointer-events: ${blockPointerEventsWhenDisabled ? 'none' : 'auto'};
        }
        `}
    `;
}}
  ${({ focused }) => focused &&
    `
    &:enabled:before {
      display: block;
    }
  `};
`;
const Loader = styled(MuiCircularProgress) `
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
`;
const Button = (_a, ref) => {
    var { hint, children, disabled, onClick, hintDuration, preventCloseHintOnClick, hintWithArrow, showHint } = _a, rest = __rest(_a, ["hint", "children", "disabled", "onClick", "hintDuration", "preventCloseHintOnClick", "hintWithArrow", "showHint"]);
    const isIconButton = React__default.isValidElement(children);
    const buttonComponent = disabled ? 'div' : undefined;
    const buttonOnClick = !disabled ? onClick : undefined;
    return (jsx(ConditionalWrapper, Object.assign({ wrapper: child => (jsx(Hint, Object.assign({ title: hint, duration: hintDuration, preventCloseHintOnTargetClick: preventCloseHintOnClick, arrow: hintWithArrow, forceShowHint: showHint }, { children: child }))), condition: !!hint }, { children: jsxs(_Button, Object.assign({ ref: ref, iconButton: isIconButton, 
            /* @ts-ignore */
            component: buttonComponent, disabled: disabled, onClick: buttonOnClick }, rest, { children: [children, rest.loading && jsx(Loader, { size: rest.size })] })) })));
};
var Button$1 = React__default.forwardRef(Button);

export { Button$1 as default };
//# sourceMappingURL=Button.js.map
